import React from "react";
import styles from "./Projects.module.css";
import { Link } from "react-router-dom";
import todo from "../../assets/todo2.png";
import weather from "../../assets/weather.png";
import calculator from "../../assets/calculator.png";
import diragram from '../../assets/dockerDiagram.png'
import scriptify from '../../assets/scriptify.png'
import bookealo from '../../assets/bookealo-bg.png'
import { FaLongArrowAltRight } from "react-icons/fa";
import pwMngr from "../../assets/pw-mngr.png";

const Projects = ({ isNavToggle }) => {
  return (
    <div className={styles.main}>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>Projects.</h1>
      </div>
      <h3 className={styles.subtitle}>Full Stack Docker Template</h3>
      <p class={styles.cardSubtitle}>
              This repository contains a full-stack application template using Docker.<br /><span className={styles.breakSpace}></span>
              The user runs a python script and it will propt you to choose the services you want in your environment.<br /><span className={styles.breakSpace}></span>
              It includes a React frontend, Node.js/Express, Python/Flask, Golang/Gin backend, and Postgresql and Redis databases
              all containerized using Docker.
              </p>
      <div
        className={styles.cardContainer}
        style={isNavToggle ? { display: "none" } : null}
      >
        {/* Element Ease */}

        <div class={styles.card} onClick={()=>{document.location.href = "https://gitlab.com/gonzalezmassini/full-stack-docker-template"}}>
          <div class={styles.cardImage}>
            <img src={diragram} alt="Full Stack Docker Template" />
          </div>
          <div class={styles.cardOverlay}>
            <div class={styles.cardHeader}>
              <h2 class={styles.cardTitle}>Full Stack Docker Template</h2>

            </div>
            <div class={styles.cardFooter}>
              <a
                href="https://gitlab.com/gonzalezmassini/full-stack-docker-template"
                target="_blank"
                rel="noopener noreferrer"
                class={styles.tag}
              >
                Gitlab
              </a>
            </div>
          </div>
        </div>
        <div>
        <h3 className={styles.subtitle}>Bookealo</h3>
          <p class={styles.cardSubtitle}>
                This repository contains the Bookealo full-stack booking platform SaaS application.<br /><span className={styles.breakSpace}></span> 
                Users can create customizable calendars and product rentals, manage appointments with real-time availability, and accept payments through integrated checkout flows.
                <br /><span className={styles.breakSpace}></span> The application features multi-tenant architecture with role-based access, automated notifications, and a landing page builder for client branding. Built with Next.js frontend, PostgreSQL database, Stripe for payments, and deployed on AWS using Amplify hosting with RDS for data persistence.
                </p>
          <div class={styles.card} onClick={()=>{document.location.href = "https://bookealo.io/"}}>
            <div class={styles.cardImage}>
              <img src={bookealo} alt="Scriptify" />
            </div>
            <div class={styles.cardOverlay}>
              <div class={styles.cardHeader}>
                <h2 class={styles.cardTitle}>Bookealo</h2>

              </div>
              <div class={styles.cardFooter}>
                <a
                    href="https://bookealo.io/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class={styles.tag}
                  >
                    Live
                </a>
                <a
                  href="https://gitlab.com/gonzalezmassini/bookealo"
                  target="_blank"
                  rel="noopener noreferrer"
                  class={styles.tag}
                >
                  Gitlab
                </a>
              </div>
            </div>
          </div>
        </div>
        <div>
        <h3 className={styles.subtitle}>Scriptify Demo</h3>
          <p class={styles.cardSubtitle}>
                This repository contains the Scriptify full-stack application.<br /><span className={styles.breakSpace}></span> 
                The user can purchase tokens and fill out a form to generate custom scripts for emails, social media posts, and more.
                <br /><span className={styles.breakSpace}></span> The application integrates with the OpenAI API to generate the content, 
                featuring a React frontend, Node.js backend, Stripe for payments and AWS Cognito for authentication.
                </p>
          <div class={styles.card} onClick={()=>{document.location.href = "https://scriptify-client.onrender.com/demo"}}>
            <div class={styles.cardImage}>
              <img src={scriptify} alt="Scriptify" />
            </div>
            <div class={styles.cardOverlay}>
              <div class={styles.cardHeader}>
                <h2 class={styles.cardTitle}>Scriptify Demo</h2>

              </div>
              <div class={styles.cardFooter}>
                <a
                    href="https://scriptify-client.onrender.com/demo"
                    target="_blank"
                    rel="noopener noreferrer"
                    class={styles.tag}
                  >
                    Live
                </a>
                <a
                  href="https://gitlab.com/gonzalezmassini/scriptify-client"
                  target="_blank"
                  rel="noopener noreferrer"
                  class={styles.tag}
                >
                  Gitlab Frontend
                </a>
                <a
                  href="https://gitlab.com/gonzalezmassini/scriptify-server"
                  target="_blank"
                  rel="noopener noreferrer"
                  class={styles.tag}
                >
                  Gitlab Backend
                </a>
              </div>
            </div>
          </div>
        </div>
        <div>
        <h3 className={styles.subtitle}>Password Manager Demo</h3>
          <p class={styles.cardSubtitle}>
            This project is a password manager application that consists of a backend written in Go and a frontend built with React. <br /><span className={styles.breakSpace}></span> 
            The backend handles user authentication and data storage using a PostgreSQL database, while the frontend provides a user interface for managing passwords.<br /><span className={styles.breakSpace}></span>  
            The project supports local development with Docker Compose and deployment on Kubernetes clusters.
          </p>
          <div class={styles.card} onClick={()=>{document.location.href = "http://100.123.124.128:30084/signup"}}>
            <div class={styles.cardImage}>
              <img src={pwMngr} alt="pw-mngr" />
            </div>
            <div class={styles.cardOverlay}>
              <div class={styles.cardHeader}>
                <h2 class={styles.cardTitle}>Password Manager Demo</h2>
              </div>
              <div class={styles.cardFooter}>
                <a
                    href="http://100.123.124.128:30084/signup"
                    target="_blank"
                    rel="noopener noreferrer"
                    class={styles.tag}
                  >
                    Live
                </a>
                <a
                  href="https://gitlab.com/gonzalezmassini/pw-mngr"
                  target="_blank"
                  rel="noopener noreferrer"
                  class={styles.tag}
                >
                  Gitlab
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={styles.ctaProjectsContainer}>
        <Link className={styles.ctaProjects} to="/">
          Go Back Home <FaLongArrowAltRight />
        </Link>
      </div> */}
    </div>
  );
};

export default Projects;
